module.exports = __webpack_public_path__ + "static/img/17.f866a29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/17.jpg
// module id = HMYl
// module chunks = 0